import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getApiInFlight } from '../services/api.service';
import { markFirstRouteMounted } from './hydration';
import { fetchLatestProviderManifest } from '../services/providerManifest.service';
import { getManifestHash, setProviderManifest } from './providerManifest';
import { consumePrerenderState } from './state';

let manifestRefreshStarted = false;

/**
 * Rendered right after the routed page inside the same Suspense boundary: effects run in tree order, so this
 * one fires after the page's own effects in the commit that hydrates the page. From then on the serialized
 * state and the "initial paint" mode are over.
 */
export const RouteStateConsumer = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    markFirstRouteMounted();
    // "Rendered" signal for the release checks (validation-suite): the routed page is hydrated and the API
    // refreshes it started are done (no request in flight for two consecutive checks).
    let quiet = 0;
    const timer = window.setInterval(() => {
      quiet = getApiInFlight() === 0 ? quiet + 1 : 0;
      if (quiet >= 2) {
        document.documentElement.dataset.ready = 'true';
        window.clearInterval(timer);
      }
    }, 150);
    consumePrerenderState(pathname);
    // A cached page may link to a profile that no longer exists: swap in the latest manifest (links drop, text stays).
    if (!manifestRefreshStarted) {
      manifestRefreshStarted = true;
      void fetchLatestProviderManifest(getManifestHash()).then((latest) => { if (latest) setProviderManifest(latest); });
    }
    return () => window.clearInterval(timer);
  }, [pathname]);
  return null;
};
